import { FDealType, FOfferType, isAvailable } from 'shared/common/packages/JsonQuery';

import { AreaContainer } from '../../containers/filters/AreaContainer';
import { IFilter } from '../../types/filters';

export const area: IFilter = {
  availability: isAvailable(FDealType.Any, FOfferType.Any),
  component: AreaContainer,
};
